export type MotivoRejeicao = 'ja_na_fila' | 'em_cooldown' | 'limite_sessao';

export class JukeboxPedidoRejeitadoError extends Error {
  readonly motivo: MotivoRejeicao;

  constructor(motivo: MotivoRejeicao) {
    super(`jukebox:${motivo}`);
    this.name = 'JukeboxPedidoRejeitadoError';
    this.motivo = motivo;
  }
}

/** Mapeia exceções da RPC `inserir_pedido_jukebox` para motivos do domínio. */
export function parseJukeboxPedidoError(error: unknown): JukeboxPedidoRejeitadoError | null {
  const msg = error && typeof error === 'object' && 'message' in error
    ? String((error as { message: string }).message)
    : String(error);

  if (msg.includes('jukebox:ja_na_fila'))     return new JukeboxPedidoRejeitadoError('ja_na_fila');
  if (msg.includes('jukebox:em_cooldown'))    return new JukeboxPedidoRejeitadoError('em_cooldown');
  if (msg.includes('jukebox:limite_sessao')) return new JukeboxPedidoRejeitadoError('limite_sessao');
  return null;
}
